import {useEffect, useRef, useState, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {initialize as initializeFeedback, sendFeedback} from '../../modules/chat/feedback';
import {readHistoryDetail} from '../../modules/chat/chat';
import {downloadDocs, initialize as initializeDownload} from '../../modules/chat/download';
import LoadingComponent from '../common/Loading';
import { ReactComponent as IconSendChat } from '../../assets/send_chat.svg';
import { ReactComponent as IconSendChatActive } from '../../assets/send_chat_a.svg';
import { ReactComponent as IconSendChatStop } from '../../assets/send_chat_stop.svg';
import { ReactComponent as IconUnion } from '../../assets/Icon_union.svg';

import {ReactComponent as ErrorIcon} from '../../assets/Icon_error.svg';
import {ReactComponent as ErrorIconBlue} from '../../assets/Icon_error_blue.svg';

import 'react-loading-skeleton/dist/skeleton.css';
import styles from './styles/chat.module.css';

import AnswerBox from './AnswerBox';
import BotBox from './BotBox';
import DetailBox from './DetailBox';
import Dropdown from './Dropdown';
import QuestionBox from './QuestionBox';
import SuggestionnBox from './SuggestionBox';
import FeedbackButtonBox from '../feedback/FeedbackButtonBox';
import FeedbackModal from '../feedback/FeedbackModal';
import FeedbackResponseModal from '../feedback/FeedbackResponseModal';
import OnboardingImg from '../../assets/chat/new-onboarding.png';

const IDEA_SAMPLE_QUESTIONS = [
    '창의혁신아이디어는 주로 어떤 내용이 있어?',
    'OOOO 아이디어 담당자는 누구야?',
    '우수사례 아이디어는 어떤 내용이야?',
    '창의혁신아이디어 제출 양식 알려줘'
];

export default function Chat({ historyId, message, chatList, isSendMessage, handleChange, handleSendMessage, handleResendMessage, handleChangeHistoryId, closeConnection, getBotListResponse, currentBot, changeCurrentBot, findBotId, normalizeHistoryChat, isStreaming, streamingType, streamingChatId, isWaitingData, setCurrentHistoryId, setChatList }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const isIdeaRoute = location.pathname.startsWith('/idea');

    const observerRef = useRef();
    const prevChatListLengthRef = useRef(0); // 이전 메시지 개수를 추적하기 위한 ref

    const { historyDetailResponse, historyDetailErrorResponse, historyIdRequested, historyDetailLoading } = useSelector(({ chat, loading }) => ({
        historyDetailResponse: chat.historyDetailResponse,
        historyDetailErrorResponse: chat.historyDetailErrorResponse,
        historyIdRequested: chat.historyIdRequested,
        historyDetailLoading: loading['chat/READ_HISTORY_DETAIL']
    }));

    const { optionList, inputText, feedbackResponse, feedbackError, feedbackLoading } = useSelector(({ feedback, loading }) => ({ // 피드백 제출 관련 전역 상태
        optionList: feedback.optionList,
        inputText: feedback.inputText,
        feedbackResponse: feedback.feedbackResponse,
        feedbackError: feedback.feedbackError,
        feedbackLoading: loading['feedback/SEND_FEEDBACK']
    }));

    const [lastChatIndex, setLastChatIndex] = useState(-1);
    const [contentPlaceholder, setContentPlaceholder] = useState('메시지를 입력해주세요.');
    const [needFeedback, setNeedFeedback] = useState(false);
    const [allChatList, setAllChatList] = useState([]);                    // 지난 채팅과 실기간 채팅을 합친 전체 채팅 내역
    console.log('allChatList : ', allChatList);
    const [isOpenFeedbackModal, setIsOpenFeedbackModal] = useState(false); // 피드백 모달 열림/닫힘 상태

    const chatRefs = useRef([]);
    const feedbackRefs = useRef([]);
    const chatContainerRef = useRef();
    const historyChatRefs = useRef([]);

    // 봇 관련 상태
    const [isOpenBotList, setIsOpenBotList] = useState(false);      // 봇 목록
    const [isOpenBotTooltip, setIsOpenBotTooltip] = useState(true); // '원하는 답변 유형을 선택하세요' 툴팁

    const [chatHistoryDetail, setChatHistoryDetail] = useState([]);
    console.log('chatHistoryDetail : ', chatHistoryDetail);
    
    const [hasMore, setHasMore] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [isAtTheBottom, setIsAtTheBottom] = useState(false);
    const [localChatIdToLoadHistory, setLocalChatIdToLoadHistory] = useState(null);
    const [observerLoading, setObserverLoading] = useState(false);

    const [hasChangeDataView, setHasChangeDataView] = useState(false);

    // 스크롤 위치 저장을 위한 변수 추가
    const [prevScrollHeight, setPrevScrollHeight] = useState(0);
    const [prevScrollPosition, setPrevScrollPosition] = useState(0);

    const toggleFeedbackModal = () => { // 피드백 모달 열고 닫는 함수
        setIsOpenFeedbackModal(!isOpenFeedbackModal);
    };

    // 답변 과정 드롭다운 변환 함수
    const updateDropdownState = (answerId) => {
        setChatHistoryDetail(prevChatList => prevChatList.map(chat => 
            answerId === chat.answerId ? { ...chat, isOpenDropdown: !chat.isOpenDropdown } : chat
        ));
    
        setChatList(prevChatList => prevChatList.map(chat => 
            answerId === chat.answerId ? { ...chat, isOpenDropdown: !chat.isOpenDropdown } : chat
        ));

        setAllChatList(prevChatList => prevChatList.map(chat => 
            answerId === chat.answerId ? { ...chat, isOpenDropdown: !chat.isOpenDropdown } : chat
        ));
    };

    // 표<->차트 변환 함수
    const updateViewType = (answerId, viewType) => {
        setChatHistoryDetail(prevChatList => prevChatList.map(chat => {
            if (chat.answerId === answerId) {
                if (!chat.data?.table || chat.data.table.length <= 0) return chat; // 데이터가 없는 경우 viewType 변경하지 않음

                return {
                    ...chat,
                    viewType: viewType
                };
            }
            return chat;
        }));
    
        setChatList(prevChatList => prevChatList.map(chat => {
            if (chat.answerId === answerId) {
                if (!chat.data?.table || chat.data.table.length <= 0) return chat;
                
                return {
                    ...chat,
                    viewType: viewType
                };
            }
            return chat;
        }));

        setAllChatList(prevChatList => prevChatList.map(chat => {
            if (chat.answerId === answerId) {
                if (!chat.data?.table || chat.data.table.length <= 0) return chat;
                
                return {
                    ...chat,
                    viewType: viewType
                };
            }
            return chat;
        }));
    };

    // 피드백 타입 변환 함수
    const updateFeedbackType = (answerId, feedbackType) => {
        setChatHistoryDetail(prevChatList => prevChatList.map(chat => 
            answerId === chat.answerId ? { ...chat, feedbackType } : chat
        ));

        setChatList(prevChatList => prevChatList.map(chat => 
            answerId === chat.answerId ? { ...chat, feedbackType } : chat
        ));

        setAllChatList(prevChatList => prevChatList.map(chat => 
            answerId === chat.answerId ? { ...chat, feedbackType } : chat
        ));
    };

    const handleClickWrapper = () => {
        if (isOpenBotTooltip) setIsOpenBotTooltip(false);
        if (isOpenBotList) setIsOpenBotList(false);
    };

    const handleOpenBotList = () => { // TODO : toggleBotList로 이름 변경
        setIsOpenBotList(!isOpenBotList);
    };

    const handleOpenBotTooltip = () => { // TODO : toggleBotTooltop으로 이름 변경
        setIsOpenBotTooltip(!isOpenBotTooltip);
    };

    const scrollToBottom = () => {
        setTimeout(() => {
            if (chatContainerRef.current) {
                chatContainerRef.current.scrollTo({
                    top: chatContainerRef.current.scrollHeight,
                    behavior: 'smooth'
                });
            }
        }, 100);
    };
    
    const scrollToCurrentChat = (index) => {
        if (chatRefs.current[index]) {
            chatRefs.current[index].scrollIntoView({ behavior: 'smooth' });
        }
    };

    const scrollToCurrentHistoryChat = (index) => {
        if (historyChatRefs.current[index]) {
            historyChatRefs.current[index].scrollIntoView({ behavior: 'instant' });
        }
    };

    const handleSend = (message) => {
        if (isSendMessage) {
            alert('답변을 작성하고 있어요!');
            return;
        }

        if (allChatList.length > 0) {
            const lastChat = allChatList[allChatList.length - 1];
            const { isRequiredFeedback, feedbackType } = lastChat;

            if (isRequiredFeedback && !feedbackType) {
                alert('피드백 작성 후 질문해 주세요.');
                return;
            }
        }

        // setLastChatIndex(chatList.length);
        handleSendMessage(message, null);
        scrollToBottom();
    };

    const handleStopMessage = () => {
        // TODO: display canceled message on chat-box
        alert('답변 생성을 중단했습니다.');
        closeConnection();
        setNeedFeedback(false);
        setContentPlaceholder('메시지를 입력해주세요.');
    };


    const validateBeforeSubmitFeedback = (answerId) => {                             // 피드백을 제출할 수 있는 상태인지 확인하는 함수
        if (!answerId) return false;                                                 // 응답 받기 전인 경우

        if (isSendMessage) return false;                                             // 응답 받는 중인 경우

        const currentChat = allChatList.find(chat => chat.answerId === answerId);
        if (!feedbackError && currentChat && currentChat.feedbackType) return false; // 이미 제출한 피드백이 있는 경우
        
        return true;
    };

    const submitFeedback = (answerId, feedbackType) => { // 피드백 전송하는 함수
        if (!validateBeforeSubmitFeedback(answerId)) return;

        updateFeedbackType(answerId, feedbackType);
        
        dispatch(sendFeedback({
            answerId,
            type: feedbackType.toLowerCase(),           // 소문자로 변환
            optionList,
            inputText
        }));

        if (!feedbackError && feedbackType === 'NEGATIVE') {
            toggleFeedbackModal();                     // close
        }
    };

    const openFeedbackModal = (answerId, index) => { // 부정적 피드백 모달 여는 함수
        if (isSendMessage) return;
        if (index !== allChatList.length - 1) return;
        if (isOpenFeedbackModal) return;
        if (feedbackError) return;

        toggleFeedbackModal();                // open
        
        scrollToBottom();
    };

    const handleSubmitFeedbackComplete = (indeㅌx, answerId, feedbackType) => {
        closeConnection();
        updateFeedbackType(answerId, feedbackType);
        // finishSubmitFeedback(index, type);
    };

    const handleClickNothingToSelect = (e, index, answerId, feedback) => {
        closeConnection();
        setNeedFeedback(true);
        // TODO : open feedback negative
    };

    const handleClickSelectionButton = (e, suggest, initMsg, chatId) => {
        // close connection and send new question
        handleResendMessage({initMsg, message: e.target.innerText, date: suggest.date, target: suggest.target, keyValue: suggest.keyValue, chatId});
        setNeedFeedback(false);
    };

    const handleClickDataView = (chatId, answerId, idx, dataView) => {
        setHasChangeDataView(true);
        const localItems = allChatList.map(chat => {            
            if (chatId === chat.chatId && answerId === chat.answerId) {
                return ({...chat,
                    answer: chat.answer.map(ans => {
                        if (idx === ans.index) {
                            return ({...ans, view: dataView})
                        } else {
                            return ans;
                        }
                    })
                })
            } else {
                return chat;
            }
        });

        setAllChatList(localItems);
    };

    const handleClickHistoryDataView = (chatId, idx, dataView) => {
        setHasChangeDataView(true);
        const localItems = chatHistoryDetail.map(chat => {            
            if (chatId === chat.id) {
                return ({...chat,
                    answerList: chat.answerList.map((answer, index) => {
                        if (idx === index) {
                            return ({...answer, view: dataView});
                        } else {
                            return answer;
                        }
                    })
                })
            } else {
                return chat;
            }
        });
        setChatHistoryDetail(localItems);
    };

    const fetchMoreData = (startKey) => {
        if (chatContainerRef.current) {
            setPrevScrollHeight(chatContainerRef.current.scrollHeight);
            setPrevScrollPosition(chatContainerRef.current.scrollTop);
        }

        // 요청 시작할 때 로딩 상태로 변경
        setObserverLoading(true);
        setIsInitialLoad(false);
        dispatch(readHistoryDetail({ id: historyId, startkey: startKey }));
    };

    const loadMoreData = useCallback(() => {
        if (historyDetailLoading) {
            console.log("⛔️ Skip: loading 중");
            return;
        }
        if (!hasMore) {
            console.log("⛔️ Skip: 더 이상 가져올 게 없음");
            return;
        }
        if ((!chatHistoryDetail || chatHistoryDetail.length < 1) && (!allChatList || allChatList.length < 1)) {
            console.log("⛔️ Skip: 가져올 대상이 없음");
            return;
        }
    
        const firstChatId = chatHistoryDetail[0]?.chatId ?? null;
        if (firstChatId) {
            fetchMoreData(firstChatId);
            setIsAtTheBottom(false);
        }
    }, [chatHistoryDetail, historyDetailLoading, hasMore]);
    

    const handleObserver = useCallback(
        (entries) => {
            const [entry] = entries;
            // observerLoading 상태 확인 추가
            if (entry.isIntersecting && !historyDetailLoading && !observerLoading && hasMore && chatContainerRef.current && chatContainerRef.current.scrollTop === 0) {
                loadMoreData();
            }
        },
        [loadMoreData, historyDetailLoading, observerLoading, hasMore]
    );

    const moveToCurrentChatRef = useCallback(async () => {
        if (chatContainerRef.current) {  // null 체크
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
            if (lastChatIndex >= 0) {
                scrollToCurrentChat(lastChatIndex);
            }
        }
    }, [lastChatIndex]);

    const downloadReference = (downloadLink) => {
        if (!downloadLink) return;

        dispatch(downloadDocs({ downloadLink }));

        dispatch(initializeDownload());
    };

    useEffect(() => {
        if (observerRef.current) {
            const observer = new IntersectionObserver(handleObserver, {
                root: null,
                threshold: 0.1, //when 10% of the target is visible
            });
            observer.observe(observerRef.current);

            return () => observer.disconnect();
        }
    }, [handleObserver]);

    useEffect(() => {
        const lastChat = allChatList[allChatList.length - 1];

        if (isSendMessage) {
            setContentPlaceholder('답변을 작성하고 있어요!');
        } else if (lastChat && lastChat.isRequiredFeedback && !lastChat.feedbackType) {
            setContentPlaceholder('피드백 작성 후 질문해 주세요.');
        } else if (lastChat && !lastChat.isRequiredFeedback && (lastChat.answerType === 'SELECTION' || lastChat.answerType === 'CHAIN')) {
            setContentPlaceholder('질문을 선택해 주세요.');
        } else {
            setContentPlaceholder('메시지를 입력해 주세요.');
        }

        const isModifiedAllChatListLength = allChatList.length > prevChatListLengthRef.current;

        if (isModifiedAllChatListLength || isSendMessage) {
            moveToCurrentChatRef();
        }
        
        prevChatListLengthRef.current = allChatList.length; // 현재 채팅 개수 저장
    }, [isSendMessage, allChatList, moveToCurrentChatRef]);

    useEffect(() => {
        if (chatList.length < 1) return;
        const localItems = chatList.map(chat => ({
            ...chat,
            answer: chat.type === 'TITLE' ? (
                chat.answer && chat.answer.length > 0 && chat.answer.map(ans => ({
                    ...ans,
                    view: !ans.data || Object.keys(ans.data).length === 0 ? 'NONE' :
                        ans.data.table && ans.data.table.length > 0
                        ? 'TABLE'
                        : ans.data.chart && ans.data.chart.length > 0
                        ? 'CHART'
                        : 'NONE'
                }))
            ) : chat.answer
        }));

        if (localItems.length > 9) {
            setLocalChatIdToLoadHistory(localItems[0] && localItems[0].chatId ? localItems[0].chatId : null);
            setHasMore(true);
        }

        setAllChatList(localItems);
        setIsAtTheBottom(true);
        // moveToCurrentChatRef();
    }, [chatList]);

    useEffect(() => {
        if (isAtTheBottom === false) return;
        if (allChatList.length + chatHistoryDetail.length > 10) {
            if (allChatList.length > 0) {
                let count = 10 - allChatList.length;
                if (chatHistoryDetail.length > 0) {
                    if (count > 0) setChatHistoryDetail(chatHistoryDetail.slice(count * -1));
                    else setChatHistoryDetail([]);
                }
                setAllChatList(allChatList.slice(-10));
                scrollToBottom();
                setHasMore(true);
            }
            moveToCurrentChatRef();
        }
    }, [allChatList]);

    useEffect(() => { // 히스토리 요청 / 선택된 history가 없으면 초기화하여 온보딩 노출
        // historyId가 변경될 때 항상 로컬 상태 초기화
        setChatHistoryDetail([]);
        setAllChatList([]);
        prevChatListLengthRef.current = 0;

        if (!historyId) {
            // /chat 또는 /idea 같은 base 경로 진입 시 직전 채팅 잔존 방지
            handleChange({ target: { name: 'historyDetailResponse', value: null } });
            handleChange({ target: { name: 'historyDetailErrorResponse', value: null } });
            return;
        }

        dispatch(readHistoryDetail({ id: historyId }));
        setIsInitialLoad(true);

        return () => {
            setObserverLoading(false);
        };
    }, [historyId]);

    useEffect(() => { // 히스토리 조회 요청 성공 처리
        if (!historyId) return; // base 경로(/chat·/idea) 진입 시 stale Redux 데이터 무시 → 온보딩 노출 보장
        if (!historyDetailLoading && historyDetailResponse) {
            setCurrentHistoryId(historyId);

            const normalizedHistoryChatList = historyDetailResponse.data.map(historyChat => normalizeHistoryChat(historyChat));
            setChatHistoryDetail(prev => [...normalizedHistoryChatList, ...prev]);
    
            // 응답에 따라 hasMore 업데이트
            setHasMore(historyDetailResponse.next);

            setObserverLoading(false);
            
            // 중요: 초기 로드 시에만 isInitialLoad를 true로 설정
            // 중간에 있는 이 두 조건문 사이의 setIsInitialLoad(true)를 제거해야 합니다!
            if (chatHistoryDetail.length === 0) {
                setIsInitialLoad(true);
            } else {
                setIsInitialLoad(false);
            }
            
            setIsOpenBotTooltip(false);

            // 중요: 여기서 스크롤 위치 복원
            if (!isInitialLoad) {
                setTimeout(() => {
                    if (chatContainerRef.current) {
                        const heightDiff = chatContainerRef.current.scrollHeight - prevScrollHeight;
                        chatContainerRef.current.scrollTop = prevScrollPosition + heightDiff;
                    }
                }, 100);
            }
        }
    }, [historyDetailLoading, historyDetailResponse]);

    useEffect(() => {
        if (!chatHistoryDetail || chatHistoryDetail.length < 1) return;
        if (hasChangeDataView) {
            setHasChangeDataView(false);
            return;
        }

        // set scroll position
        if (isInitialLoad && (chatHistoryDetail.length < 1)) {
            scrollToBottom(); //chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
            return;
        }

        if (chatHistoryDetail.length > 10) {
            scrollToCurrentHistoryChat(8);
            setIsAtTheBottom(false);
            return;
        }
        if (chatHistoryDetail.length > 8 && allChatList.length > 0) {
            scrollToCurrentHistoryChat(8); // 10 - 2 means the count of loading skeleton chatbox
        } else if (allChatList.length > 0) {
            scrollToCurrentHistoryChat(chatHistoryDetail.length - 1);
        }
        else scrollToBottom(); //chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;        
        setIsAtTheBottom(false);

        if (chatHistoryDetail.length > 0) {
            changeCurrentBot({
                id: findBotId(chatHistoryDetail[chatHistoryDetail.length - 1].botType),
                type: chatHistoryDetail[chatHistoryDetail.length - 1].botType
            });
        }
    }, [chatHistoryDetail]);

    useEffect(() => {
        if (historyDetailErrorResponse) {
            setIsOpenBotTooltip(false);
            setObserverLoading(false);
        }
    }, [historyDetailErrorResponse]);

    useEffect(() => {
        return () => {
            handleChange({ target: { name: 'historyDetailResponse', value: null }});
            handleChange({ target: { name: 'historyDetailErrorResponse', value: null }});
            setChatHistoryDetail([]);
            setAllChatList([]);
        };
    }, [historyId]);

    useEffect(() => {
        const mergedChatList = [...chatHistoryDetail, ...chatList];

        setAllChatList(mergedChatList);
    }, [chatHistoryDetail, chatList]);

    useEffect(() => { // 피드백 전송 요청 성공
        if (!feedbackLoading && feedbackResponse) {
            const { answerId, type } = feedbackResponse;
            const feedbackType = type.toUpperCase();

            updateFeedbackType(answerId, feedbackType);

            dispatch(initializeFeedback());

            closeConnection();
        }
    }, [feedbackLoading, feedbackResponse]);

    return (
        <div className={styles.wrapper} onClick={handleClickWrapper}>
            <div className={styles.chatContainer} ref={(el) => chatContainerRef.current = el}>
                {!historyDetailLoading && !historyDetailResponse && !historyDetailErrorResponse && allChatList.length < 1 &&
                    (isIdeaRoute ? (
                        <div style={{ flex: 1, width: '100%', minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 20px', boxSizing: 'border-box' }}>
                            <div
                                style={{
                                    width: '100%',
                                    maxWidth: 820,
                                    padding: '36px 40px',
                                    borderRadius: 20,
                                    backgroundColor: '#fff',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 24
                                }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                    <p style={{ fontSize: 22, fontWeight: 800, color: 'var(--gray-darker, #222)', margin: 0, letterSpacing: '-0.01em' }}>
                                        창의혁신아이디어 예상 질문
                                    </p>
                                    <p style={{ fontSize: 14, color: 'var(--gray, #6b7280)', margin: 0 }}>
                                        아래 질문을 참고해 자유롭게 물어보세요.
                                    </p>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 12 }}>
                                    {IDEA_SAMPLE_QUESTIONS.map((q, idx) => (
                                        <div
                                            key={idx}
                                            style={{
                                                display: 'flex',
                                                gap: 12,
                                                padding: '16px 18px',
                                                fontSize: 15,
                                                color: 'var(--gray-darker, #222)',
                                                lineHeight: 1.5,
                                                backgroundColor: 'var(--gray-lighter, #f7f6ff)',
                                                border: '1px solid transparent',
                                                borderRadius: 12,
                                                transition: 'border-color 0.15s ease, background-color 0.15s ease, transform 0.15s ease',
                                                cursor: 'default'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.borderColor = 'var(--main_purple, #6a3ff6)';
                                                e.currentTarget.style.backgroundColor = '#fff';
                                                e.currentTarget.style.transform = 'translateY(-1px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.borderColor = 'transparent';
                                                e.currentTarget.style.backgroundColor = 'var(--gray-lighter, #f7f6ff)';
                                                e.currentTarget.style.transform = 'translateY(0)';
                                            }}
                                        >
                                            <span style={{ fontWeight: 800, color: 'var(--main_purple, #6a3ff6)', flexShrink: 0 }}>Q{idx + 1}.</span>
                                            <span>{q}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div style={{ flex: 1, width: '100%', minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 20px', boxSizing: 'border-box' }}>
                            <img src={OnboardingImg} alt='' style={{ width: '100%', maxWidth: '880px' }} />
                        </div>
                    ))
                }
                {historyDetailErrorResponse && chatHistoryDetail.length < 1 && allChatList.length < 1 && 
                    <>
                        {historyDetailErrorResponse.code !== 403 ?
                        <div className={styles.errorHistoryLoad}>
                            <ErrorIcon/>
                            <div>대화내역을 불러오는 중&nbsp;<span>오류</span>&nbsp;발생</div>
                            <p>잠시 후 다시 시도해 주세요.</p>
                        </div> :
                        <div className={styles.errorHistoryLoad}>
                            <ErrorIcon/>
                            <div>접근 권한 없음</div>
                            <p>관리자에게 문의해 주세요.</p>
                        </div>}
                    </>
                }

                {historyDetailErrorResponse && (chatHistoryDetail.length > 0 || allChatList.length > 0) &&
                    <div className={`${styles.chatBox} ${styles.chatBoxSkeleton}`} style={{marginBottom: '120px'}}>
                        <div className={styles.quesBox}>
                            <div className={styles.skeletonBotIcon}></div>
                            <div className={styles.skeletonQuestionSmall}></div>
                        </div>
                        <div className={`${styles.skeletonAnswer} ${styles.errorHistoryLoad}`}>
                            <ErrorIconBlue/>
                            <div>대화를 불러오는 중&nbsp;<span style={{color: 'var(--main_purple)'}}>오류</span>&nbsp;발생</div>
                            <p>잠시 후 다시 시도해 주세요.</p>
                        </div>
                    </div>
                }

                {historyDetailLoading && !historyDetailErrorResponse &&
                    <>
                        <div style={{marginTop: '50px', marginBottom: '80px'}}>
                            <LoadingComponent/>
                        </div>
                        {Array(2).fill(null).map((_, index) => (
                            <div key={`skeleton-loading${index}`} className={`${styles.chatBox} ${styles.chatBoxSkeleton}`} style={ index < 1 ? {marginBottom: '80px'} : {marginBottom: '120px'}}>
                                <div className={styles.quesBox}>
                                    <div className={styles.skeletonBotIcon}></div>
                                    <div className={styles.skeletonQuestionSmall}></div>
                                </div>
                                <div className={styles.skeletonAnswer}></div>
                                <div className={styles.skeletonQuestionLarge}></div>
                                <div className={styles.skeletonQuestionMedium}></div>
                            </div>))}
                    </>
                }

                {!historyDetailErrorResponse && hasMore &&
                    <div className={styles.observerRef} ref={observerRef}></div>
                }

                {allChatList.map((chat, index) => (
                    <div
                        key={`${chat.chatId}-${index}`}
                        ref={(el) => chatRefs.current[index] = el}
                        style={index === allChatList.length - 1 ? { marginBottom: '58px' } : {}}
                        className={styles.chatBox}
                    >
                        <QuestionBox 
                            botType={chat.botType}
                            question={chat.question}
                        />

                        {isSendMessage && !chat.answerId && (index === allChatList.length - 1) && 
                            <div className={styles.containerAnswer}>
                                <div className={styles.boxReady}>
                                    <p>정보를 불러오고 있습니다. 잠시만 기다려 주세요.</p>
                                    <div className={styles.readyCursor}></div>
                                </div>
                            </div>
                        }

                        {/* TODO : 응답 박스 분리 */}
                        {chat.answerId &&
                            <div
                                key={`${chat.chatId}-${chat.answerId}`}
                                className={styles.containerAnswer}
                            >
                                {chat.thinkString &&
                                    <DetailBox
                                        title='사고 과정'
                                        content={chat.thinkString}
                                        isStreaming={isStreaming && streamingChatId === chat.chatId}
                                        isOpenDropdown={chat.isOpenDropdown}
                                        toggleDropdown={() => updateDropdownState(chat.answerId)}
                                    />
                                }
                                <AnswerBox
                                    isStreaming={isStreaming}
                                    isWaitingData={isWaitingData}
                                    streamingChatId={streamingChatId}
                                    chat={chat}
                                    updateViewType={updateViewType}
                                    downloadReference={downloadReference}
                                />
                                <FeedbackButtonBox
                                    index={index}
                                    answerId={chat.answerId}
                                    feedbackType={chat.feedbackType}
                                    submitFeedback={submitFeedback}
                                    openFeedbackModal={openFeedbackModal}
                                    feedbackError={feedbackError}
                                />
                            </div>
                        }

                        {(index === allChatList.length - 1) && !chat.feedbackType && isOpenFeedbackModal &&
                            <FeedbackModal
                                ref={(el) => feedbackRefs.current[index] = el}
                                optionList={optionList}
                                inputText={inputText}
                                answerId={chat.answerId}
                                submitFeedback={submitFeedback}
                                toggleFeedbackModal={toggleFeedbackModal}
                            />
                        }

                        {(index === allChatList.length - 1) && (!feedbackLoading && feedbackError) &&
                            <FeedbackResponseModal
                                answerId={chat.answerId}
                                feedbackType={chat.feedbackType}
                                error={feedbackError}
                                submitFeedback={submitFeedback}
                            />
                        }
                    </div>      
                        
                ))}
            </div>

            <div className={styles.inputWrapper}>
                {/* 봇 선택 UI - 현재 문서 챗봇만 사용하므로 일시 비활성화
                <div className={styles.botWrapper} style={isOpenBotTooltip ? {top: '-21px'} : {}}>
                    {isOpenBotTooltip &&
                        <div className={styles.botTooltipWrapper} onClick={handleOpenBotTooltip}>
                            <div className={styles.botTooltip}>
                                <span>원하는 답변 유형을 선택하세요</span>
                            </div>
                            <IconUnion />
                        </div>
                    }

                    <BotBox
                        getBotListResponse={getBotListResponse}
                        currentBot={currentBot}
                        isOpenBotList={isOpenBotList}
                        isOpenBotTooltip={isOpenBotTooltip}
                        changeCurrentBot={changeCurrentBot}
                        handleOpenBotList={handleOpenBotList}
                    />
                </div>
                */}
                <div className={styles.inputContainer}>
                    <input className={styles.input}
                        placeholder={contentPlaceholder}
                        type='text'
                        name='message'
                        value={message}
                        onChange={handleChange}
                        onKeyPress={e => e.key === 'Enter' ? handleSend(message) : undefined}
                        autoComplete='off'
                    />
                    {!isSendMessage ? 
                        needFeedback
                        ? <IconSendChat className={styles.btn} onClick={e => handleSend(message)}/> :
                        <IconSendChatActive className={styles.btn} onClick={e => handleSend(message)}/>
                    : <IconSendChatStop className={styles.btn} onClick={handleStopMessage}/>}
                </div>
            </div>
        </div>
    );
}
